module.exports = __webpack_public_path__ + "static/media/Bacheloroppgave.1a98336d.pdf";